/*
 * @Author: your name
 * @Date: 2022-04-26 16:19:33
 * @LastEditTime: 2022-04-28 10:25:27
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /ksh-doctor/src/utils/tencent.js
 */

import Vue from 'vue'
import { saveBeforeFacePath } from './util'
Vue.prototype.$onJumpTencentAuth = (obj) => {
  // 腾讯第三方人脸校验
  saveBeforeFacePath(obj.path || window.location.pathname)
  let reqUrl = `https://${obj.optimalDomain}/api/web/login?`
  delete obj['optimalDomain']
  //  存储路径
  delete obj['path']
  // 腾讯人脸识别请求
  Object.keys(obj).map((v, i, arr) => {
    if (v === 'url') {
      // 对url 进行转码
      obj[v] = window.encodeURIComponent(obj[v])
    }
    if (i < arr.length - 1) {
      reqUrl += `${v}=${obj[v]}&`
    } else {
      reqUrl += `${v}=${obj[v]}`
    }
  })
  window.location.href = reqUrl
}
